import { toast } from '../contexts/NotificationContext';

export default toast;
export { toast };
